import {
  CheckOutlined,
  PictureOutlined,
  PlayCircleOutlined,
} from '@ant-design/icons';
import classNames from 'classnames';

import type { InstagramPublication } from '@app/components/Modals/BotDetailsModal/types';

import { useInstagramPublicationCard } from '../hooks/useInstagramPublicationCard';

import type { FC } from 'react';

import './InstagramPublicationCard.scss';

interface InstagramPublicationCardProps {
  publication: InstagramPublication;
  isSelected: boolean;
  // Предел достигнут — новую публикацию выбрать нельзя
  isDisabled: boolean;
  onToggle: (instagramId: string) => void;
}

export const InstagramPublicationCard: FC<InstagramPublicationCardProps> = ({
  publication: {
    instagramId,
    isReels,
    typeLabel,
    previewUrl,
    caption,
    permalink,
    publishedAtLabel,
  },
  isSelected,
  isDisabled,
  onToggle,
}) => {
  const { isPreviewShown, linkAriaLabel, previewErrorHandler, toggleHandler } =
    useInstagramPublicationCard({
      instagramId,
      previewUrl,
      publishedAtLabel,
      onToggle,
    });

  return (
    <div
      className={classNames('InstagramPublicationCard', {
        'InstagramPublicationCard--selected': isSelected,
        'InstagramPublicationCard--disabled': isDisabled,
      })}
      data-testid="instagram-publication-card"
    >
      <button
        type="button"
        className="InstagramPublicationCard__toggle"
        aria-pressed={isSelected}
        disabled={isDisabled}
        onClick={toggleHandler}
      >
        <span className="InstagramPublicationCard__preview">
          {isPreviewShown && previewUrl ? (
            <img
              className="InstagramPublicationCard__image"
              src={previewUrl}
              alt=""
              loading="lazy"
              onError={previewErrorHandler}
              data-testid="instagram-publication-image"
            />
          ) : (
            <span
              className="InstagramPublicationCard__placeholder"
              data-testid="instagram-publication-placeholder"
            >
              {isReels ? (
                <PlayCircleOutlined aria-hidden />
              ) : (
                <PictureOutlined aria-hidden />
              )}
              <span>Превью недоступно</span>
            </span>
          )}

          <span className="InstagramPublicationCard__type">{typeLabel}</span>

          {isSelected && (
            <span className="InstagramPublicationCard__check">
              <CheckOutlined aria-hidden />
            </span>
          )}
        </span>

        <span
          className={classNames('InstagramPublicationCard__caption', {
            'InstagramPublicationCard__caption--empty': !caption,
          })}
        >
          {caption ?? 'Без подписи'}
        </span>

        {publishedAtLabel && (
          <span className="InstagramPublicationCard__date">
            {publishedAtLabel}
          </span>
        )}
      </button>

      {permalink && (
        <a
          className="InstagramPublicationCard__link"
          href={permalink}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={linkAriaLabel}
        >
          Открыть в Instagram
        </a>
      )}
    </div>
  );
};
